import Page from './page';
import SplitQuantitySelector from '../components/inputs/split-quantity-selector';
import InitialOrderCartForm from '../components/initial-order/initial-order-cart-form';

export default class InitialOrderSplitCartPage extends Page {

  private initialOrderCartForm: InitialOrderCartForm;

  constructor(body: JQuery) {
    super(true);
    this.initialOrderCartForm = new InitialOrderCartForm(body.find('.js-initial-order-cart-form'));
  }

  init(): void {
    super.init();
    SplitQuantitySelector.initAll();
  }
}
